module.exports = __webpack_public_path__ + "img/Huile-vidange-153517859.14d571d1.jpg";